import FileSaver from 'file-saver'
import Vue from 'vue'
import i18n from '../i18n'

const downloadFile = (type, title, bookTitle, items) => {
  let content = ''

  if (type === 'notes') {
    content = `${title} | ${bookTitle} | ${i18n.t('DBOK_READER')}`

    items.forEach(item => {
      content = `${content}\r\n\r\n${item.quote}\r\n${item.text}\r\ns. ${item.page}, ${Vue.filter('formatDate')(item.created)}`
    })
  }
  if (type === 'highlights') {
    content = `${title} | ${bookTitle} | ${i18n.t('DBOK_READER')}`

    items.forEach(item => {
      content = `${content}\r\n\r\n${item.quote}\r\ns. ${item.page}, ${Vue.filter('formatDate')(item.created)}`
    })
  }

  const blob = new Blob([content], { type: 'text/plain;charset=utf-8' })
  FileSaver.saveAs(blob, `${i18n.t('DBOK_FILE')}.txt`)
}

export default downloadFile